module.exports = __webpack_public_path__ + "img/bgc033.aca06976.png";